import { Injectable } from "@nestjs/common";
import { ShiftDto } from "./dto/shifts.dto";
import { ShiftsEntity } from "./entities/shifts.entity";

@Injectable()
export class ShiftAdapter {
    public convertDtoToEntity(dto: ShiftDto, isUpdate: boolean = false): ShiftsEntity {
        const entity = new ShiftsEntity();
        entity.id = dto.id;
        entity.shift = dto.shift;
        entity.inTime = dto.inTime;
        entity.outTime = dto.outTime;
        entity.dayChange = dto.dayChange;
        entity.updatedUser = dto.updatedUser;
        entity.updatedAt = dto.updatedAt;
        entity.createdUser = dto.createdUser;
        entity.isActive = dto.isActive === undefined ? true : dto.isActive;
        if (isUpdate) {
            entity.isActive = true;
        }
        return entity;

    }

    public convertEntityToDto(entity: ShiftsEntity): ShiftDto {
        const dto = new ShiftDto();
        dto.id = entity.id;
        dto.shift = entity.shift;
        dto.inTime = entity.inTime;
        dto.outTime = entity.outTime;
        dto.dayChange = entity.dayChange;
        dto.isActive = entity.isActive;
        dto.createdAt = entity.createdAt;
        dto.createdUser = entity.createdUser;
        dto.updatedAt = entity.updatedAt;
        dto.updatedUser = entity.updatedUser;
        dto.versionFlag = entity.versionFlag;
        return dto;
    }
}